module.exports = __webpack_public_path__ + "static/media/about1.9f441d0d.jpg";